import React from 'react';
import Vday from './vday';

function App() {
    return <Vday/>;
}

export default App;
